import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { GenericTypeaheadComponent } from './generic-typeahead.component';

@NgModule({
  declarations: [
    GenericTypeaheadComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule
  ],
  exports: [
    GenericTypeaheadComponent
  ]
})
export class GenericTypeaheadModule { }
